export interface RegimenFormValues {
  id: string;
  codigo: string;
  descripcion: string;
  valor: string;
}

export function validateRegimenForm(
  form: Pick<RegimenFormValues, 'codigo' | 'descripcion' | 'valor'>,
): Partial<Record<keyof RegimenFormValues, string>> {
  const errors: Partial<Record<keyof RegimenFormValues, string>> = {};
  const codigo = form.codigo.trim();
  if (!codigo) {
    errors.codigo = 'El código es requerido';
  } else if (!/^-?\d+$/.test(codigo)) {
    errors.codigo = 'El código debe ser un número entero';
  }
  if (!form.descripcion.trim()) {
    errors.descripcion = 'La descripción es requerida';
  }
  if (!form.valor.trim()) {
    errors.valor = 'El valor es requerido';
  }
  return errors;
}

export function toRegimenPayload(form: RegimenFormValues): {
  id?: number;
  codigo: number;
  descripcion: string;
  valor: string;
} {
  return {
    ...(form.id ? { id: Number(form.id) } : {}),
    codigo: Number(form.codigo.trim()),
    descripcion: form.descripcion.trim(),
    valor: form.valor.trim(),
  };
}
